@if (storeService.getScreenType() === ScreenType.STRONA_GLOWNA) {
<div class="fdx-o-grid fdx-o-grid--max-width">
  <app-page-header [title]="'Nadaj swoją przesyłkę bez logowania'">
    Chcesz nadać lub zwrócić przesyłkę z gotową etykietą?<br />
    A może chcesz utworzyć zupełnie nową przesyłkę?<br />
    Wybierz jedną z poniższych opcji.
  </app-page-header>

  <app-main-option-buttons-wrapper>
    <app-main-option-button
      class="fdx-o-grid__item--4 fdx-o-grid__item--3@medium"
      (click)="iHaveReadyLabelButtonAction()"
      [label]="'Mam gotową etykietę'"
      [iconPathForActiveButton]="'assets/images/document_icon_white.png'"
      [iconPathForInActiveButton]="'assets/images/document_icon_grey.png'"
      [isActive]="isLabelReadySelected()"></app-main-option-button>
    <app-main-option-button
      class="fdx-o-grid__item--4 fdx-o-grid__item--3@medium"
      (click)="iWantToCreateNewShipmentButtonAction()"
      [label]="'Chcę utworzyć przesyłkę'"
      [iconPathForActiveButton]="'assets/images/parcel_icon_white.png'"
      [iconPathForInActiveButton]="'assets/images/parcel_icon_grey.png'"
      [isActive]="!isLabelReadySelected()"></app-main-option-button>
  </app-main-option-buttons-wrapper>

  <form [formGroup]="mainPageForm" (keydown.enter)="$event.preventDefault()">
    @if (isLabelReadySelected()) {
    <div class="fdx-u-mb--5 fdx-u-mt--10">
      <app-form-header>
        Wprowadź numer listu przewozowego <br />
        oraz kod pocztowy miejsca nadania.
      </app-form-header>

      <div
        class="fdx-o-grid__row fdx-o-grid__row--center fdx-o-grid__row--guttered-small fdx-u-mt--5">
        <app-form-input-control
          class="fdx-o-grid__item--start fdx-o-grid__item--4@large fdx-o-grid__item--4@medium fdx-o-grid__item--5"
          [formField]="parcelNumberInput"
          [labelName]="'WPISZ NUMER PRZESYŁKI *'">
          <input
            type="text"
            class="fdx-c-form-group__input fdx-u-px--4"
            id="parcel_number_input"
            formControlName="parcel_number_input"
            [maxLength]="20"
            (input)="
              this.formService.onInputForNumberField2($event, parcelNumberInput)
            " />
        </app-form-input-control>

        <app-form-input-control
          class="fdx-o-grid__item--start fdx-o-grid__item--4@large fdx-o-grid__item--4@medium fdx-o-grid__item--5"
          [formField]="zipCodeInput"
          [labelName]="'KOD POCZTOWY *'">
          <input
            type="text"
            class="fdx-c-form-group__input fdx-u-px--4"
            id="zip_code_input"
            formControlName="zip_code_input"
            pattern="^[0-9]{2}-[0-9]{3}$"
            maxlength="6"
            (input)="this.formService.formatZipCode($event)" />
        </app-form-input-control>
      </div>
    </div>
    } @if (!isLabelReadySelected()) {
    <div class="fdx-u-mb--5 fdx-u-mt--10">
      <app-form-header>
        Wprowadź numer Klienta krajowego FedEx (ID CSK)<br />
        i naciśnij DALEJ by przejść do kolejnego kroku.
      </app-form-header>

      <div
        class="fdx-o-grid__row fdx-o-grid__row--center fdx-o-grid__row--guttered-small fdx-u-mt--5">
        <app-form-input-control
          class="fdx-o-grid__item--8@large fdx-o-grid__item--8@medium fdx-o-grid__item--10"
          [formField]="clientNumberInput"
          [labelName]="'NUMER KLIENTA *'">
          <input
            type="text"
            class="fdx-c-form-group__input fdx-u-px--4"
            id="client_number_input"
            formControlName="client_number_input"
            [maxLength]="40"
            (input)="
              this.formService.onInputForNumberField2($event, clientNumberInput)
            " />
        </app-form-input-control>
      </div>
    </div>
    }

    <div class="fdx-o-grid__row fdx-u-mb--10">
      <div class="fdx-o-grid__item fdx-u-align--center">
        <div class="fdx-o-grid__row">
          <div class="fdx-o-grid__item">
            <p class="fdx-u-font-size--small fdx-u-color--purple">
              Przepisz wyrazy z obrazka
            </p>
          </div>
        </div>

        <div
          class="fdx-o-grid__row fdx-o-grid__row--center fdx-u-align--center">
          <div>
            <div class="fdx-o-grid__row">
              <div
                class="fdx-c-form-group fdx-c-form-group--top-label"
                [ngClass]="{
                    'fdx-c-form-group--is-invalid':
                      captchaInput?.touched && captchaInput?.invalid,
                  }">
                <span class="fdx-c-form-group__item">
                  @if (storeService.getCaptchaB64()) {
                  <img
                    [src]="
                      'data:image/jpeg;base64,' + storeService.getCaptchaB64()
                    "
                    alt="CAPTCHA Image"
                    style="width: 200px; height: 40px" />
                  } @if (!storeService.getCaptchaB64()) {
                  <div
                    class="fdx-o-grid__row fdx-o-grid__row--center"
                    style="width: 200px; height: 40px">
                    @if (captchaLoadingError()) {
                    <div
                      role="alert"
                      id="alertID"
                      class="fdx-c-form-group__message fdx-c-form-group__message--has-message fdx-u-color--error">
                      <div
                        class="fdx-c-form-message__icon"
                        style="margin-right: 5px">
                        <svg
                          class="fdx-c-icon"
                          aria-hidden="true"
                          focusable="false"
                          role="presentation">
                          <use xlink:href="#utility_cross-fat"></use>
                        </svg>
                      </div>
                      <span>Błąd ładowania obrazka.</span>
                    </div>
                    } @if (!captchaLoadingError()) {
                    <div
                      class="fdx-c-loader fdx-c-loader--medium fdx-o-grid__item--center"></div>
                    }
                  </div>
                  }
                  <div
                    class="fdx-c-form-group__input"
                    style="width: 200px; height: 40px; margin-top: 4px">
                    <input
                      type="text"
                      class="fdx-u-px--4 fdx-u-bg-color--white"
                      id="captcha_input"
                      (keydown.enter)="onSubmit()"
                      formControlName="captcha_input"
                      [maxLength]="20"
                      style="width: 200px; height: 40px" />
                  </div>
                </span>
                <app-form-field-error-messages [formField]="captchaInput">
                </app-form-field-error-messages>
              </div>
            </div>
          </div>
          <div style="padding-left: 5px">
            <div class="fdx-o-grid__row">
              <div class="fdx-o-grid__item">
                <button
                  class="fdx-c-button fdx-c-button--square-condensed fdx-c-button--primary fdx-u-border--none fdx-u-bg-color--purple fdx-u-color--white"
                  (click)="reloadCaptcha()">
                  <div class="fdx-c-button__icon" aria-hidden="true">
                    <svg
                      class="fdx-c-icon"
                      aria-hidden="true"
                      focusable="false"
                      role="presentation">
                      <use xlink:href="#utility_sync"></use>
                    </svg>
                  </div>
                </button>
              </div>
            </div>
            <div class="fdx-o-grid__row">
              <div class="fdx-o-grid__item">
                <button
                  (mouseenter)="showTooltip()"
                  (mouseleave)="hideTooltip()"
                  class="fdx-c-button fdx-c-button--square-condensed fdx-c-button--primary fdx-u-border--none fdx-u-bg-color--purple fdx-u-color--white fdx-u-mt--1">
                  <div class="fdx-c-button__icon" aria-hidden="true">?</div>
                </button>
                <div *ngIf="isTooltipVisible" class="fdx-c-tooltip__main">
                  <div class="fdx-c-tooltip__main__body">
                    Przepisz wyrazy z obrazka.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <app-form-error-message
      [submitException]="submitException()"
      [form]="mainPageForm">
    </app-form-error-message>

    <div class="fdx-o-grid__row fdx-o-grid__row--center fdx-u-mb--5">
      <app-submit-button
        [isLoading]="isSubmitLoading()"
        [isDisabled]="mainPageForm.invalid"
        [buttonText]="'DALEJ'"
        (clickEvent)="onSubmit()">
      </app-submit-button>
    </div>
  </form>
</div>
}
<!-- <div class="dialog">
  <fdx-location-shared [searchLocation]="locLatLng" [config]="{channelId: 'XXXX', listOnly: true}">
  </fdx-location-shared>
</div> -->
